import { BaseModel } from '../lib';


export default class UserModel extends BaseModel {


}
